module.exports = __webpack_public_path__ + "img/gohome.a6d36960.svg";